import formHandler from './form_handler';

const validation = {
    init() {
        jQuery.validator.addMethod('whitespaceonly', function (value, element) {
            return this.optional(element) || !/^\s+$/.test(value);
        });
        jQuery.validator.addMethod('selected', (value, element) => value.length > 0);

        $('.js--validate_form').each((i, form) => {
            const name = 'agency_name';
            const $name = $(form).find('input[name="agency_name"]');
            const tel = 'phone';
            const $tel = $(form).find('input[name="phone"]');
            const email = 'email';
            const $email = $(form).find('input[name="email"]');
            const password = 'passwd';
            const $password = $(form).find('input[name="passwd"]');
            const password_confirmation = 'password_confirmation';
            const confirmation = 'confirmation';
            const $password_confirmation = $(form).find('input[name="password_confirmation"]');
            const $confirmation = $(form).find('input[name="confirmation"]');

            $(form).validate({
                ignore: '',
                rules: {
                    [confirmation]: {
                        equalTo: $password,
                    },
                    [password_confirmation]: {
                        equalTo: $password,
                    },
                },
                messages: {
                    [password_confirmation]: {
                        equalTo: $password_confirmation.data('error-confirmation'),
                    },
                    [confirmation]: {
                        equalTo: $confirmation.data('error-confirmation'),
                    },
                },
                errorElement: 'span',
                errorPlacement(error, element) {
                    // const selector = `${$(element).prop('nodeName').toLowerCase()}`;
                    error.appendTo(element.siblings('.form__error_wrapper'));
                },
                // errorContainer: '.form_input__error',
                highlight(element) {
                    // const selector = `${$(element).prop('nodeName').toLowerCase()}`;
                    $(element.closest('.form-group')).addClass('form-group--error');
                    $(element.closest('.form-group')).removeClass('form-group--ok');
                },
                unhighlight(element) {
                    // const selector = `${$(element).prop('nodeName').toLowerCase()}`;
                    $(element.closest('.form-group')).removeClass('form-group--error');
                    $(element.closest('.form-group')).addClass('form-group--ok');
                },
                submitHandler() {
                    $(form).find('input').not('input[name="password"]').val((i, val) => val.trim());
                    $(form).find('textarea').val((i, val) => val.trim());

                    switch ($(form).attr('id')) {
                        case 'question':
                            formHandler.setCurrentForm(this).question();
                            break;
                        case 'login_form':
                            formHandler.setCurrentForm(this).login();
                            break;
                        case 'call_back_form':
                            formHandler.setCurrentForm(this).callBack();
                            break;
                        case 'certificate_form':
                            formHandler.setCurrentForm(this).callBack();
                            break;
                        case 'submitIdentity':
                            formHandler.setCurrentForm(this).identity();
                            break;
                        case 'form_forgotpassword':
                            formHandler.setCurrentForm(this).submit();
                            break;
                        case 'checkout_forgot_form':
                            formHandler.setCurrentForm(this).forgotPasswordSubmit();
                            break;
                        case 'forgot_popup_form':
                            formHandler.setCurrentForm(this).forgotPasswordSubmit();
                            break;

                        case 'login_form_content':
                            formHandler.setCurrentForm(this).checkoutLoginSend();
                            break;
                        case 'user_detected':
                            formHandler.setCurrentForm(this).userDetectedSubmit();
                            break;
                        case 'reg_agency_form':
                            formHandler.setCurrentForm(this).registration();
                            break;
                        case 'reg_form':
                            formHandler.setCurrentForm(this).registration();
                            break;
                        case 'join_tour_form':
                            formHandler.setCurrentForm(this).callBack();
                            break;
                        case 'join_tour_form_category':
                            formHandler.setCurrentForm(this).callBack();
                            break;
                        case 'join_tour_form_infolists':
                            formHandler.setCurrentForm(this).callBack();
                            break;
                        default:
                            break;
                    }
                },
            });
            $('.rule-minlength').each(function () {
                setTimeout((field) => {
                    $(field).rules('add', {
                        minlength: 5,
                        messages: {
                            minlength: $(field).data('error-minlength'),
                        },
                    });
                }, 0, this);
            });
            $('.rule-email').each(function () {
                setTimeout((field) => {
                    $(field).rules('add', {
                        email: true,
                        messages: {
                            email: $(field).data('error-email'),
                        },
                    });
                }, 0, this);
            });
            $('.rule-whitespace').each(function () {
                setTimeout((field) => {
                    $(field).rules('add', {
                        whitespaceonly: true,
                        messages: {
                            whitespaceonly: $(field).data('error-whitespace'),
                        },
                    });
                }, 0, this);
            });
            $('.rule-required').each(function () {
                setTimeout((field) => {
                    $(field).rules('add', {
                        required: true,
                        messages: {
                            required: $(field).data('error-required'),
                        },
                    });
                }, 0, this);
            });
            $('.rule-selected').each(function () {
                setTimeout((field) => {
                    $(field).rules('add', {
                        selected: true,
                        messages: {
                            selected: $(field).data('error-selected'),
                        },
                    });
                }, 0, this);
            });
            $('.rule-numbers').each(function () {
                setTimeout((field) => {
                    $(field).rules('add', {
                        number: true,
                        messages: {
                            number: $(field).data('error-numbers'),
                        },
                    });
                }, 0, this);
            });
            $('.rule-phone').each(function () {
                setTimeout((field) => {
                    $(field).rules('add', {
                        required: true,
                        messages: {
                            required: $(field).data('error-required'),
                        },
                    });
                    $(field).rules('add', {
                        minlength: 19,
                        messages: {
                            minlength: $(field).data('error-tel'),
                        },
                    });
                }, 0, this);
            });
        });
        formHandler.initCheckOutHandlers();
    },
};

export default validation;
